import { render, staticRenderFns } from "./addWorksModal.vue?vue&type=template&id=6643da64&"
import script from "./addWorksModal.vue?vue&type=script&lang=js&"
export * from "./addWorksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports